import type { FC, SVGProps } from 'react'
import AccountTreeIcon from 'src/assets/icons/material-symbols/outlined/account_tree.svg?react'
import AnchorIcon from 'src/assets/icons/material-symbols/outlined/anchor.svg?react'
import ArrowBackIcon from 'src/assets/icons/material-symbols/outlined/arrow_back.svg?react'
import ArrowDownwardIcon from 'src/assets/icons/material-symbols/outlined/arrow_downward.svg?react'
import ArrowUpwardIcon from 'src/assets/icons/material-symbols/outlined/arrow_upward.svg?react'
import AutoAwesomeIcon from 'src/assets/icons/material-symbols/outlined/auto_awesome.svg?react'
import CalculateIcon from 'src/assets/icons/material-symbols/outlined/calculate.svg?react'
import CategoryIcon from 'src/assets/icons/material-symbols/outlined/category.svg?react'
import ChatBubbleIcon from 'src/assets/icons/material-symbols/outlined/chat_bubble.svg?react'
import CheckIcon from 'src/assets/icons/material-symbols/outlined/check.svg?react'
import CheckCircleFillIcon from 'src/assets/icons/material-symbols/outlined/check_circle-fill.svg?react'
import CheckCircleIcon from 'src/assets/icons/material-symbols/outlined/check_circle.svg?react'
import ChevronRightIcon from 'src/assets/icons/material-symbols/outlined/chevron_right.svg?react'
import CloudUploadIcon from 'src/assets/icons/material-symbols/outlined/cloud_upload.svg?react'
import ContentCopyIcon from 'src/assets/icons/material-symbols/outlined/content_copy.svg?react'
import CropSquareIcon from 'src/assets/icons/material-symbols/outlined/crop_square.svg?react'
import DescriptionIcon from 'src/assets/icons/material-symbols/outlined/description.svg?react'
import DownloadIcon from 'src/assets/icons/material-symbols/outlined/download.svg?react'
import DragIndicatorIcon from 'src/assets/icons/material-symbols/outlined/drag_indicator.svg?react'
import EditIcon from 'src/assets/icons/material-symbols/outlined/edit.svg?react'
import EditNoteIcon from 'src/assets/icons/material-symbols/outlined/edit_note.svg?react'
import ExpandLessIcon from 'src/assets/icons/material-symbols/outlined/expand_less.svg?react'
import ExpandMoreIcon from 'src/assets/icons/material-symbols/outlined/expand_more.svg?react'
import FilterAltFillIcon from 'src/assets/icons/material-symbols/outlined/filter_alt-fill.svg?react'
import FilterAltIcon from 'src/assets/icons/material-symbols/outlined/filter_alt.svg?react'
import GroupWorkIcon from 'src/assets/icons/material-symbols/outlined/group_work.svg?react'
import HowToRegFillIcon from 'src/assets/icons/material-symbols/outlined/how_to_reg-fill.svg?react'
import HowToRegIcon from 'src/assets/icons/material-symbols/outlined/how_to_reg.svg?react'
import ImageIcon from 'src/assets/icons/material-symbols/outlined/image.svg?react'
import InfoIcon from 'src/assets/icons/material-symbols/outlined/info.svg?react'
import PictureAsPdfIcon from 'src/assets/icons/material-symbols/outlined/picture_as_pdf.svg?react'
import PlaylistRemoveIcon from 'src/assets/icons/material-symbols/outlined/playlist_remove.svg?react'
import SaveIcon from 'src/assets/icons/material-symbols/outlined/save.svg?react'
import SearchIcon from 'src/assets/icons/material-symbols/outlined/search.svg?react'
import SortByAlphaIcon from 'src/assets/icons/material-symbols/outlined/sort_by_alpha.svg?react'
import SquareFootIcon from 'src/assets/icons/material-symbols/outlined/square_foot.svg?react'
import StickyNote2Icon from 'src/assets/icons/material-symbols/outlined/sticky_note_2.svg?react'
import TrendingDownIcon from 'src/assets/icons/material-symbols/outlined/trending_down.svg?react'
import UndoIcon from 'src/assets/icons/material-symbols/outlined/undo.svg?react'
import ViewModuleIcon from 'src/assets/icons/material-symbols/outlined/view_module.svg?react'
import WarningIcon from 'src/assets/icons/material-symbols/outlined/warning.svg?react'

export type MaterialSymbolSvg = FC<SVGProps<SVGSVGElement>>

export const MATERIAL_SYMBOL_ICONS = {
  account_tree: { regular: AccountTreeIcon },
  anchor: { regular: AnchorIcon },
  arrow_back: { regular: ArrowBackIcon },
  arrow_downward: { regular: ArrowDownwardIcon },
  arrow_upward: { regular: ArrowUpwardIcon },
  auto_awesome: { regular: AutoAwesomeIcon, filled: AutoAwesomeIcon },
  calculate: { regular: CalculateIcon },
  category: { regular: CategoryIcon },
  chat_bubble: { regular: ChatBubbleIcon },
  check: { regular: CheckIcon },
  check_circle: { regular: CheckCircleIcon, filled: CheckCircleFillIcon },
  chevron_right: { regular: ChevronRightIcon },
  cloud_upload: { regular: CloudUploadIcon },
  content_copy: { regular: ContentCopyIcon },
  crop_square: { regular: CropSquareIcon },
  description: { regular: DescriptionIcon },
  download: { regular: DownloadIcon },
  drag_indicator: { regular: DragIndicatorIcon },
  edit: { regular: EditIcon },
  edit_note: { regular: EditNoteIcon },
  expand_less: { regular: ExpandLessIcon },
  expand_more: { regular: ExpandMoreIcon },
  filter_alt: { regular: FilterAltIcon, filled: FilterAltFillIcon },
  group_work: { regular: GroupWorkIcon },
  how_to_reg: { regular: HowToRegIcon, filled: HowToRegFillIcon },
  image: { regular: ImageIcon },
  info: { regular: InfoIcon },
  picture_as_pdf: { regular: PictureAsPdfIcon },
  playlist_remove: { regular: PlaylistRemoveIcon },
  save: { regular: SaveIcon },
  search: { regular: SearchIcon },
  sort_by_alpha: { regular: SortByAlphaIcon },
  square_foot: { regular: SquareFootIcon },
  sticky_note_2: { regular: StickyNote2Icon },
  trending_down: { regular: TrendingDownIcon },
  undo: { regular: UndoIcon },
  view_module: { regular: ViewModuleIcon },
  warning: { regular: WarningIcon },
} as const

export type MaterialSymbolName = keyof typeof MATERIAL_SYMBOL_ICONS
